
export const setActiveComponent  = (value) => {
    return {
        type: "SET_ACTIVE_COMPONENT",
        payload: value,
    };
};